import { render } from "./CostReporterBeta.vue?vue&type=template&id=5754b292"
import script from "./CostReporterBeta.vue?vue&type=script&lang=js"
export * from "./CostReporterBeta.vue?vue&type=script&lang=js"

import "./CostReporterBeta.vue?vue&type=style&index=0&id=5754b292&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__